import GameCell from './GameCell';

export default GameCell;
